import { render } from "./flats-crm-filter-mobile.vue?vue&type=template&id=f487b3c2"
import script from "./flats-crm-filter-mobile.vue?vue&type=script&lang=js"
export * from "./flats-crm-filter-mobile.vue?vue&type=script&lang=js"

import "./flats-crm-filter-mobile.vue?vue&type=style&index=0&id=f487b3c2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__